import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SitesParis = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Sites de Paris Sportifs en France</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
          <section>
            <p className="text-gray-700 text-lg leading-relaxed">
              Découvrez notre sélection des <strong>meilleurs sites de paris sportifs</strong> agréés en France. 
              Tous les bookmakers présentés sur 123pariez.com possèdent une licence délivrée par l'ANJ 
              (Autorité Nationale des Jeux), garantissant la sécurité de vos fonds et la fiabilité des opérations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Comment choisir son bookmaker ?</h2>
            <p className="text-gray-700 mb-4">
              Le choix d'un site de paris sportifs dépend de plusieurs critères essentiels :
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-3">
              <li><strong>La licence ANJ :</strong> Assurez-vous que l'opérateur est agréé en France</li>
              <li><strong>Les cotes proposées :</strong> Comparez les cotes entre différents bookmakers</li>
              <li><strong>Le bonus de bienvenue :</strong> Évaluez l'offre de bienvenue et ses conditions</li>
              <li><strong>Les moyens de paiement :</strong> Vérifiez les options de dépôt et retrait</li>
              <li><strong>L'application mobile :</strong> La qualité de l'app pour parier en mobilité</li>
              <li><strong>Le service client :</strong> Disponibilité et réactivité du support</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Les leaders du marché français</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold text-lg text-gray-900">Winamax</h3>
                <p className="text-gray-600 mt-2">
                  Leader français du poker et des paris sportifs. Interface intuitive, 
                  application mobile de référence et communauté active.
                </p>
              </div>
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold text-lg text-gray-900">PMU</h3>
                <p className="text-gray-600 mt-2">
                  Institution du pari hippique en France, PMU s'est diversifié avec succès 
                  dans les paris sportifs et le poker.
                </p>
              </div>
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold text-lg text-gray-900">Betclic</h3>
                <p className="text-gray-600 mt-2">
                  Bookmaker français de référence, sponsor de grands événements sportifs 
                  avec une offre complète de paris.
                </p>
              </div>
              <div className="border rounded-lg p-4">
                <h3 className="font-semibold text-lg text-gray-900">Unibet</h3>
                <p className="text-gray-600 mt-2">
                  Opérateur européen majeur, reconnu pour son live streaming 
                  et ses cotes compétitives.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">La régulation des paris en France</h2>
            <p className="text-gray-700">
              Depuis 2010, les paris sportifs en ligne sont légaux en France sous le contrôle de l'ARJEL, 
              devenue ANJ en 2020. Cette autorité veille à la protection des joueurs, à l'intégrité 
              des compétitions sportives et à la prévention du jeu excessif. Seuls les opérateurs 
              agréés sont autorisés à proposer leurs services aux joueurs français.
            </p>
          </section>

          <section className="bg-amber-50 border border-amber-200 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-amber-800 mb-3">Jouez responsable</h2>
            <p className="text-amber-700">
              Les paris sportifs sont un divertissement qui comporte des risques. Ne pariez jamais 
              plus que ce que vous pouvez vous permettre de perdre. Les jeux d'argent sont interdits 
              aux mineurs. En cas de difficulté, contactez Joueurs Info Service au 09 74 75 13 13.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default SitesParis;
